var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tooltip',{attrs:{"textAlign_prop":"left","textPosition_prop":"bottom-right","maxWidth_prop":"max-w-100 text-xs","iconHeight_prop":"0.75rem","iconWidth_prop":"0.75rem","iconColor_prop":_vm.colorGrey8,"tooltipClass_prop":"p-5"}},[_c('MarkdownRenderer',{attrs:{"content":_vm.$store.state.glossaries.totalPayment.body}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }